import { PriceHistory } from '../../services/priceHistory/types';

export const comparePriceHistories = (
  priceHistory1: PriceHistory,
  priceHistory2: PriceHistory,
) => {
  if (!priceHistory1 || !priceHistory2) {
    return null;
  }

  const priceDifference = priceHistory2.medianPrice - priceHistory1.medianPrice;
  const absolutePriceDifference = Math.abs(priceDifference);
  const percentageDifference = (
    (absolutePriceDifference / priceHistory2?.medianPrice) *
    100
  ).toFixed(2);

  return {
    priceDifference,
    absolutePriceDifference,
    percentageDifference,
  };
};
